import { useDevicesQuery } from './useDevicesQuery.hook';

export function useDevicesFromStoreQuery(storeId?: string, enabled = true) {
  return useDevicesQuery(storeId, 'store.id', enabled);
}
